// import { Button } from 'antd';
import { getRazorpayStatusByPayment } from 'api/nach';
import { NotFound } from 'common/components';
import Loading from 'features/nach/components/Loading';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
// import generatePDF from 'react-to-pdf';

const CustomText = ({ title, value }: any) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 5px 10px' }}>
      <span style={{ fontWeight: '600', fontSize: '16px' }}>{title}</span>
      <span style={{ fontSize: '16px', fontWeight: '400' }}>{value} </span>
    </div>
  );
};

function RazorpayNachPaymentSummary() {
  const state = useLocation().state as any;
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);
  const componentRef = useRef<any>();
  console.log('res state ', state);
  const [statusData, setStatusData] = useState<any>();
  // const paymentId = '';
  if (!state) {
    return <NotFound />;
  }
  useEffect(() => {
    setIsLoading(true);
    handleRetry();
  }, [state]);
  const handleRetry = () => {
    if (state.mandateId && state.paymentId) {
      setCount(count + 1);
      getRazorpayStatusByPayment({
        paymentId: state.paymentId,
        mandateId: state.mandateId,
        nachtype: state.nachType,
      })
        .then((res) => {
          console.log('razorpay order status ', res);
          debugger;
          if (res.status == 'SUCCESS' && res.data) {
            setStatusData(res.data);

            if (res.data.mandateStatus === 'MANDATE_APPROVED' && res.data.successURL) {
              window.location.href = res.data.successURL;
              return; // Stop further execution
            } else if (res.data.mandateStatus === 'MANDATE_REJECTED' && res.data.failureURL) {
              window.location.href = res.data.failureURL;
              return; // Stop further execution
            }

            //const navType = performance.navigation.type;
            // if (res.data.status == 'captured' && navType != 1) {
            // approveNachMandate({ mandateId: state.mandateId }).then(() => {
            //   console.log('approvemandate order status ', res);
            // });
            // }
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  // id , amount , mandateId,status,order_id,invoice_id

  return (
    <>
      {isLoading ? (
        <Loading isLoading={isLoading} />
      ) : (
        <div ref={componentRef} style={{ display: 'flex', justifyContent: 'center' }}>
          <div
            draggable
            style={{
              width: '600px',
              padding: '40px',
              backgroundColor: 'white',
              marginBottom: '40px',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '20px 20px',
                alignItems: 'center',
              }}
            >
              <img src="/logo.png" alt="logo" width={150} />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '2px',
              }}
            >
              <p
                style={{
                  fontWeight: '500',
                  wordSpacing: '2px',
                  letterSpacing: '1px',
                  fontSize: '20px',
                  marginBottom: '5px',
                }}
              >
                NACH Mandate Summary
              </p>
              {/* <p> */}
              <span
                style={{
                  fontWeight: '700',
                  width: '100%',
                  textAlign: 'center',
                  backgroundColor: '#ccc',
                  fontSize: '15px',
                  padding: '10px',
                }}
              >
                Mandate Summary
              </span>
            </div>
            {statusData ? (
              <div>
                {statusData.status && (
                  <CustomText
                    title="Status"
                    value={
                      <span style={{ fontWeight: '600', textTransform: 'uppercase' }}>
                        {statusData.status}
                      </span>
                    }
                  />
                )}
                {state.mandateId && (
                  <CustomText title="Mandate Request ID" value={state.mandateId} />
                )}
                {statusData.id && <CustomText title="PaymentId" value={statusData.id} />}
                {(statusData.amount >= 0 || statusData.amount <= 0) && (
                  <CustomText title="Mandate Amount" value={'₹ ' + statusData.amount} />
                )}
                {statusData.order_id && <CustomText title="Order Id" value={statusData.order_id} />}
                {statusData.invoice_id && (
                  <CustomText title="Invoice id" value={statusData.invoice_id} />
                )}
              </div>
            ) : null}

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '20px',
                alignItems: 'center',
              }}
            >
              {/* {statusData ? (
                <Button
                  type="primary"
                  onClick={() => generatePDF(componentRef, { filename: `statement.pdf` })}
                >
                  Save
                </Button>
              ) : (
                <Button disabled={count > 3} onClick={handleRetry}>
                  Please Retry
                </Button>
              )} */}

              {/* {statusData && (
                <Button disabled={count > 3} onClick={handleRetry}>
                  Please Retry
                </Button>
              )} */}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default RazorpayNachPaymentSummary;
